import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './must-have-to-explanation';

const mainimage = '/Images/must-have-to.webp';

const sections = [
  { label: "Grammar", description: "Practice must, have to, need to, should, mustn't, don't have to, etc.", type: "quiz", subtype: "must-have-to" },
];

const MustHaveTo = () => (
  <GrammarPageLayout
    level="B1"
    title="Must / Have to / Need to / Should"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Exercises: Must, Have to, Need to, Should"
    seoDescription="Practice obligation, necessity, prohibition and advice with must, have to, need to, should, mustn't, don't have to. B1 level grammar exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B1"
  />
);

export default MustHaveTo;